const state = {
  gradingModel: false,
  enquiryModal: false,
  bookingModal: false,
  teamMemberModal: null,
};

const mutations = {
  SET_GRADING_MODAL(state, showModal) {
    state.gradingModel = showModal;
  },

  SET_SHOW_ENQUIRY_MODAL(state, showModal) {
    state.enquiryModal = showModal;
  },

  SET_SHOW_BOOKING_MODAL(state, showModal) {
    state.bookingModal = showModal;
  },

  SET_TEAM_MEMBER_MODAL(state, id) {
    state.teamMemberModal = id;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
